import React, { useEffect, useRef } from "react";
import { Container, Grid } from "@mui/material";
import CustomButton from "../CustomButton";
import ProductCard from "../ProductCard";
import { PRODUCT_LIST } from "../../../constants/lang";
import { CUSTOM_BUTTON_OPTIONS } from "../../../constants/optionsConfig";

const { products: productLabel, viewAll } = PRODUCT_LIST;

const ProductList = ({ products = [], setCount = () => {}, isViewMoreVisible = true, productsContainerRef, loading, isError }) => {
  const viewMoreRef = useRef(null);
  const observerRef = useRef(null);

  useEffect(() => {
    if (!isViewMoreVisible || loading || isError) return;
    
    if (observerRef.current) {
      observerRef.current.disconnect();
    }

    observerRef.current = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setCount((prev) => prev + 1);
        }
      },
      { threshold: 1.0 }
    );

    setTimeout(() => {
      if (viewMoreRef.current) {
        observerRef.current.observe(viewMoreRef.current);
      }
    }, 800);

    return () => {
      if (observerRef.current) observerRef.current.disconnect();
    };
    // eslint-disable-next-line
  }, [isViewMoreVisible, products.length, isError, loading]);

  if (!products.length) return null;

  return (
    <>
      <Container 
        ref={productsContainerRef}
        disableGutters
        aria-label={productLabel}
        sx={{
          padding: 0,
          maxWidth: 'unset !important',
        }}
      >
        <Grid 
          container 
          spacing={2.125} // 17px converted to MUI spacing unit
        >
          {products?.map((item) => (
            <Grid 
              item 
              xs={6}    // 1 item per row on extra small screens
              sm={6}     // 2 items per row on small screens
              md={4}     // 3 items per row on medium screens
              lg={3}     // 4 items per row on large screens
              xl={3}     // 4 items per row on extra large screens
              key={item?.id}
            >
              <ProductCard
                minHeight
                item={item}
                isFavouriteIconVisible
                height="auto"
                mobileWidth="0 1 calc(50% - 16px)"
                fullWidth={true}
              />
            </Grid>
          ))}
        </Grid>
      </Container>

      <div ref={viewMoreRef}>
      </div>
      {products?.length > 12 && isViewMoreVisible && (
        <CustomButton
          isLoading={loading}
          onClick={() => setCount((prev) => prev + 1)}
          className="button"
          areaLabel={viewAll}
          category="secondary"
          size={CUSTOM_BUTTON_OPTIONS.S7}
        >
          {viewAll}
        </CustomButton>
      )}
    </>
  );
};

export default ProductList;
